import React, { Dispatch } from 'react';
import axios from 'ps-components/lib/apiClient';
import { Stack } from '@mantine/core';
import { List } from '../../../../../components/common/List';
import { Detail } from '../Detail';
import { useQuery } from 'react-query';
import { ReportInspectorAction, ReportInspectorState } from '../store';

interface ReportCategoryProps {
  categoryPk: number;
  state: ReportInspectorState
  dispatch: Dispatch<ReportInspectorAction>
}

const ReportCategory: React.FC<ReportCategoryProps> = ({ categoryPk, state, dispatch }) => {
  const { joinDetails } = state

  const fetchCategory = async () => {
    const response = await axios.apiGet(
      `/api/marketpay-internal/report-inspector/getReportCategory?categoryPk=${categoryPk}`
    );

    if (response.data.success) {
      dispatch({ type: 'setJoinDetails', payload: response.data.category.joins.sort((a: any, b: any) => a.order - b.order)[0] })
      return response.data.category
    }

    return null
  };

  const { data: category } = useQuery(['category', { categoryPk }], fetchCategory, { refetchOnWindowFocus: false })

  if (!category) return <></>

  const categoryJoins = category.joins.sort((a: any, b: any) => a.order - b.order)
  const columns = [
    { label: 'Category Join PK', field: 'pk' },
    { label: 'Order', field: 'order' },
    { label: 'Table', field: 'table' },
    { label: 'Aggregates', field: 'aggregates', format: (field: string) =>  !!field ? 'True' : 'False'},
    { label: 'Mandatory', field: 'mandatory', format: (field: string) =>  !!field ? 'True' : 'False'},
    { label: 'Data Source PK', field: 'dataSourcePk' }
  ]

  return (
    <Stack gap={15}>
      <Detail label='Title' value={category.title} />
      <Detail label='Category PK' value={category.pk} />
      <Detail label='Category Code' value={category.code} />
      <Detail label='Active' value={`${category.active ? 'True' : 'False'}`} />
      <Detail label='Allow Group By' value={category.allowGroupBy} />
      <Detail label='ACL' value={category.acl} code />
      <Detail label='Metadata' value={category.metadata} code />
      <List
        data={categoryJoins}
        dataCount={categoryJoins.length}
        columns={columns}
        uniqueKey='pk'
        activeKey={joinDetails?.pk}
        title='Category Joins'
        handleSelect={(row) => dispatch({ type: 'setJoinDetails', payload: row })}
        h='100%'
      />
      {joinDetails && (
        <>
          <Detail label='Pretty Clause' value={joinDetails.clause.and?.map((join: any) => `${join.left} ${join.operator ?? ''} ${join.right ?? ''}`)?.join(' and ')} />
          <Detail label='Clause' value={joinDetails.clause} code />
          <Detail label='Join Metadata' value={joinDetails.metadata} code />
        </>
      )}

    </Stack>
  );
};

export default ReportCategory;
